<template>

<div class="summary" :class="{'is-invalid': !isValid}">

    <template v-if="isValid && !is.updating">

        {{ summary }}

    </template>

    <i class="fa-solid fa-spinner fa-spin summary-loading" v-if="isValid && is.updating" />

    <template v-if="!isValid">

        Enter the required values.

    </template>

</div>

</template>

<script>

import $filter from '@/filter'

export default {

    props: ['type', 'value', 'isValid'],

    data: function() {

        return {
            is: {
                updating: false
            },
            summary: ''
        }

    },

    mounted: async function() {

        await this.refreshSummary()

    },

    watch: {

        value: {
            deep: true,
            handler: async function() {

                await this.refreshSummary()

            }
        }

    },

    methods: {

        refreshSummary: async function() {

            this.is.updating = true

            this.summary = await $filter.summarise(this.value, this.$route)

            this.is.updating = false

        }

    }

}

</script>

<style scoped>

.summary {
    padding: 10px;  
    text-align: center; 
    color: #fff;
    font-size: 14px;
    line-height: 18px;
    min-height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    background-color: #22465A;
    margin: 0px 10px;
    border-radius: 10px;
}

.summary.is-invalid {
    background-color: #e25555;
}

.summary-loading {
    font-size: 16px;
}

</style>